module.exports = {"430472003":"华兴街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430472.json
// module id = 1844
// module chunks = 0